import { DadosCadastrais } from '../atoms/forms/DadosCadastrais'
import DescontoDSR from '../atoms/forms/DescontoDSR'
import EmpresaPontoForm from '../atoms/forms/EmpresaPontoForm'
import OutrosDados from '../atoms/forms/OutrosDados'

export const tabs = [
    {
        name: 'empresa',
        label: 'Cadastro',
        content: <DadosCadastrais />,
    },
    {
        name: 'ponto',
        label: 'Ponto',
        content: <EmpresaPontoForm />,
    },
    {
        name: 'dsr',
        label: 'Desconto de DSR',
        content: <DescontoDSR />,
    },
    {
        name: 'outros',
        label: 'Outros',
        content: <OutrosDados />,
    },
]
